import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, Output, EventEmitter, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { Template } from '../../../_models/index';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectComponent),
      multi: true
    }
  ],
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '*',
        opacity: 1,
      })),
      state('closed', style({
        height: '0',
        opacity: 0,
        overflow: 'hidden',
      })),
      transition('open <=> closed', [
        animate('0.3s ease-in-out')
      ]),
    ]),
  ],
})
export class CustomSelectComponent implements ControlValueAccessor {
  
  @Input() options: Template[] | string[] = [];
  @Input() placeholder: string = "";
  @Output() selectedOption = new EventEmitter<string>();
  @Input() version: 'V1' | 'V2' = 'V1';
  @Input() designVersion?: 'V1' = 'V1';

  private onChange: (value: any) => void = () => { };
  private onTouch: () => void = () => { };

  isOpen = false;
  selectedValue: string | undefined;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: Template | string) {
    let valueChanged: string;

    if (this.version === 'V1' && typeof option !== 'string') {
      this.selectedValue = option.label;
      valueChanged = option.id;
    } else if (this.version === 'V2' && typeof option === 'string' ) {
      this.selectedValue = option;
      valueChanged = option;
    }

    this.isOpen = false;
    this.onChange(valueChanged);
    this.onTouch();
    this.selectedOption.emit(valueChanged);
  }

  writeValue(value: Template | string): void {
    if (this.version === 'V1' && typeof value !== 'string' ) {
      this.selectedValue = value.label;
    } else if (this.version === 'V2' && typeof value === 'string') {
      this.selectedValue = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void { }
}

